{
  "Account": {
    "AcceptTerms": "J'accepte les <a href=\"pdf/Conditions_d_utilisation.pdf\" target=\"_blank\">conditions d'utilisation</a>",
    "ConfirmEmail": {
      "ConfirmationInProgress": "Votre adresse e-mail est en cours de validation, veuillez patienter.",
      "ConfirmationTokenFailed": "Le lien a expiré entre-temps. Veuillez demander un nouveau lien.",
      "EmailConfirmed": "Votre e-mail a été confirmé. Vous pouvez maintenant vous connecter à l'application.",
      "ResendConfirmationEmailButton": "Renvoyer le lien.",
      "Title": "Confirmer l'adresse e-mail"
    },
    "Errors": {
      "EmailInvalid": "Veuillez saisir une adresse e-mail valide ",
      "EmailRequired": "Veuillez saisir votre adresse e-mail",
      "EmployedFromRequired": "Veuillez remplir \"Employé par\"",
      "FirstNameRequired": "Veuillez saisir votre prénom",
      "FunctionRequired": "Veuillez saisir le titre de spécialiste",
      "GlnRequired": "Le GLN est nécessaire pour l'enregistrement en tant que médecin.",
      "LastNameRequired": "Veuillez saisir votre nom",
      "PasswordConfirmRequired": "Veuillez confirmer le mot de passe",
      "PasswordRequired": "Veuillez choisir un mot de passe",
      "PasswordsDoNotMatch": "Les mots de passe ne correspondent pas",
      "TermsAcceptedRequired": "Vous devez accepter les conditions d'utilisation",
      "UserNameRequired": "Veuillez saisir un nom d'utilisateur"
    },
    "ForgotPassword": {
      "PasswordForgottenTitle": "Mot de passe oublié"
    },
    "HinLinked": {
      "BackToDashboard": "Retour au tableau de bord",
      "Cancelled": "Le lien de connexion HIN a été annulé.",
      "Error": "Votre login HIN n'a pas pu être associé.",
      "Success": "Connexion HIN liée avec succès. Vous pouvez dès à présent vous connecter avec HIN."
    },
    "Login": {
      "ForgotPasswordTitle": "Mot de passe oublié",
      "LoginTitle": "Inscription",
      "RegistrationTitle": "Inscription"
    },
    "Register": {
      "AccreditedInfo": "Accrédité par (plusieurs choix possibles)",
      "AccreditedInfoReadonly": "Accrédité automatiquement",
      "CityPlaceholder": "Lieu",
      "Delegate": "Délégation",
      "Doctor": "Médecin agréé",
      "EmailPlaceholder": "Adresse E-mail",
      "ExplanationPractice": "Indication du cabinet ou de l'institut dans lequel le médecin agréé exerce une activité indépendante ou est employé par un tiers.",
      "ExplanationPracticeTitle": "Explication",
      "FirstnamePlaceholder": "Prénom",
      "FormDataForDelegates": "Pour les délégations : données nécessaires",
      "FormDataForDoctors": "Pour les médecins : données nécessaires pour les contrats",
      "FunctionHint": "<a href=\"https://www.healthreg-public.admin.ch/medreg/search\" target=\"_blank\">Registre des professions médicales</a>",
      "FunctionPlaceholder": "Titre de spécialiste (tous) ou fonction",
      "GlnObligatory": "<b>Le GLN est obligatoire.</b>",
      "GlnPlaceholder": "GLN personnel",
      "InstitutionGroupAdmin": "Administrateur du groupe de cliniques",
      "InstitutionGroupAdminOrganisation": "Administrateur du groupe hospitalier",
      "InstitutionNamePlaceholder": "Institution/clinique",
      "Insurance": "Assurance",
      "InsuranceContractManager": "Responsable des contrats",
      "InsuranceFunctionSelection": "Veuillez sélectionner votre fonction",
      "InsurancePlaceholder": "Choisir une assurance",
      "InsuranceReviewer": "contrôleur de performance",
      "InsuranceSelection": "Pour quelle compagnie d'assurance travaillez-vous ?",
      "LastnamePlaceholder": "Nom de famille",
      "Others": "Autres",
      "PasswordConfimPlaceholder": "Confirmer le mot de passe",
      "PasswordPlaceholder": "Choisir un mot de passe",
      "PersonalEmailIsRequired": "Pour conclure un contrat, il faut impérativement disposer d'une adresse e-mail personnelle !",
      "RegisterButton": "S'inscrire",
      "Registration": "Inscription",
      "RegistrationInfo": "Les nouveaux utilisateurs peuvent s'inscrire ici.",
      "RegistrationInfoApprovalRequired": "Ils ne seront activés qu'après vérification de leur autorisation.",
      "RegistrationSucceeded": "<b>Nous avons bien reçu votre demande.</b> Vous recevrez un e-mail dès que votre compte sera activé.",
      "SelfIdentification": "Veuillez sélectionner votre fonction",
      "StreetPlaceholder": "Rue",
      "Title": "Inscription à l'Intranet Medicalculis",
      "TitlePlaceholder": "Titre Dr.med. / Prof.",
      "ZSRNumberHint": "<b>Veuillez saisir votre numéro RCC personnel, si vous en disposez.</b><br>Vous pouvez rechercher votre numéro RCC <a href=\"{{zsrUrl}}\" target=\"_blank\"> ici.</a>",
      "ZSRNumberPlaceholder": "Numéro RCC personnel"
    },
    "ResendConfirmEmail": {
      "Errors": {
        "NoEmailSetText": "Aucune adresse e-mail n'a été enregistrée pour cet utilisateur.",
        "NoEmailSetTitle": "Pas d'adresse e-mail enregistrée."
      },
      "ResendConfirmed": "L'e-mail de confirmation a été envoyé à nouveau. Veuillez vérifier votre boîte de réception et cliquer sur le lien de confirmation.",
      "ResendInProgress": "L'e-mail de confirmation est à nouveau envoyé, veuillez patienter.",
      "Title": "Renvoyer le lien de confirmation par e-mail"
    }
  },
  "Admin": {
    "Emails": {
      "Errors": {
        "NoEmailsSelectedText": "Veuillez sélectionner au moins un journal des événements.",
        "NoEmailsSelectedTitle": "Aucun journal des événements sélectionné."
      },
      "Header": "E-mails",
      "ResetMultipleEmailErrors": "Réinitialiser le statut d'erreur",
      "ResetMultipleEmailErrorsConfirmationDialogText": "Veuillez confirmer que vous souhaitez réinitialiser le statut d'erreur des e-mails sélectionnés. (Seuls les e-mails avec un statut d'erreur seront réinitialisés) ",
      "ResetMultipleEmailErrorsConfirmationDialogTitle": "Réinitialiser le statut d'erreur"
    },
    "EventLogs": {
      "EmailsDialogTitle": "E-mails de EventLog \"{{id}}\"",
      "Errors": {
        "NoEventLogsSelectedText": "Veuillez sélectionner au moins un journal des événements.",
        "NoEventLogsSelectedTitle": "Aucun journal des événements sélectionné."
      },
      "Header": "Journaux d'événements",
      "ReferenceId": "ID de référence",
      "ReferenceType": "Référence Type",
      "ResendEmails": "Renvoyer des e-mails",
      "ResendEmailsConfirmationDialogText": "Veuillez confirmer que les e-mails doivent être envoyés ultérieurement pour les journaux d'événements sélectionnés. (Les e-mails seront à nouveau générés à partir du modèle et ensuite envoyés).",
      "ResendEmailsConfirmationDialogTitle": "Renvoyer des e-mails",
      "ShowEmailsButtonToolTip": "Afficher les e-mails",
      "Text": "Texte",
      "Timestamp": "Date",
      "Type": "Type"
    },
    "Info": {
      "ApplicationLockoutEnabled": "Bloquer l'application",
      "DisplayWarningMessage": "Afficher le texte d'avertissement",
      "Header": "Info admin",
      "InvoiceInfoDialogPage": "Page de dialogue Invoice Info",
      "LockoutText": "Texte pour le blocage. (S'affiche sur la page de connexion)",
      "SmsCredits": "Crédits SMS",
      "SmsSentInLastQuarter": "Total des SMS utilisés au cours du dernier trimestre",
      "WarningMessage": "Texte d'avertissement"
    },
    "Rules": {
      "AddRule": "Ajouter une règle",
      "Catalog": "Catalogue",
      "Context": "Contexte",
      "DeleteRule": "Supprimer une règle",
      "DeleteRuleText": "Faut-il vraiment supprimer cette règle ?",
      "EditRule": "Modifier la règle",
      "Errors": {
        "ContextRequired": "Le contexte doit être rempli.",
        "ExpressionRequired": "La règle doit être remplie.",
        "MessageRequired": "Message à remplir.",
        "NameRequired": "Le nom doit être rempli.",
        "OrderRequired": "L'ordre doit être rempli."
      },
      "Expression": "Règle",
      "Header": "Règles",
      "IsActive": "Actif",
      "Message": "Message",
      "Order": "Ordre",
      "ResultType": "Type de résultat",
      "RuleResultTypes": {
        "Error": "Erreur",
        "Warning": "Avertissement"
      },
      "Triggers": "Déclencheur"
    }
  },
  "Anesthesia": {
    "Class": "Classe d'anesthésie",
    "ClassLabel": "Classe d'anesthésie {{class}}",
    "Date": "Date",
    "Duration": "Durée de l'intervention (hh:mm)",
    "DurationHours": "Heures",
    "DurationMinutes": "Minutes",
    "EmergencySurcharge": "Supplément d'urgence 30% (000.2200.0)",
    "Errors": {
      "MinDuration": "La durée de l'intervention doit être d'au moins 30 minutes."
    },
    "FlatRateHint": "Remarque : si elle existe, la position de forfait d'honoraires correspondante (9XX.XXX.5) doit être utilisée.",
    "Preview": "Positions"
  },
  "BankAccount": {
    "ValidQrIban": "QR-IBAN valide",
    "ValidRegularIban": "IBAN valide"
  },
  "Catalog": {
    "CatalogItemTypes": {
      "AdditionalAssistant": "Chaque assistant supplémentaire",
      "FirstAssistant": "Premier assistant",
      "FlatRateForAssistant": "Prestation forfaitaire pour les assistants",
      "FlatRateForMainServiceProvider": "Prestation forfaitaire pour le prestataire principal",
      "FlatRateSurcharge": "Supplément pour prestation forfaitaire",
      "Surcharge": "Supplément pour position tarifaire",
      "TariffPosition": "Position tarifaire",
      "Visit": "Visite",
      "VisitFlatRateSurcharge": "Supplément pour la visite médicale"
    },
    "EditCatalogItem": {
      "PreEditDialog": {
        "CreateNew": "Créer une nouvelle entrée",
        "EditExisting": "Modifier l'existant",
        "Text": "Voulez-vous modifier l'entrée existante ou créer une nouvelle entrée sur la base de cette entrée ?",
        "Title": "Entrée Modifier ou créer"
      },
      "PreEditDialogOnlyEdit": {
        "Text": "Une nouvelle entrée a déjà été dérivée sur la base de cette entrée. L'entrée ne peut être que modifiée.",
        "Title": "Modifier l'entrée"
      }
    },
    "EditCatalogView": {
      "AdditionalInfo": "Texte d'information",
      "CatalogViewOrder": "Ordre d'affichage",
      "ColumnPrefix": "Colonne",
      "ColumnWidth": "Largeur",
      "DefaultSort": "Tri standard",
      "Filter": "Filtre",
      "HideColumn": "Masquer une colonne dans un tableau",
      "IsActive": "Actif",
      "ShowColumn": "Afficher la colonne dans le tableau",
      "TableWidth": "Largeur du tableau"
    },
    "Errors": {
      "ColumnRequired": "Cette entrée doit obligatoirement être remplie.",
      "UserNotAuthorizedForCatalogViewText": "Vous n'êtes pas autorisé à consulter ce catalogue."
    },
    "Management": {
      "AddCatalogItem": "Ajouter un poste",
      "CatalogItemFilterDate": "Filtrer les entrées du catalogue par date",
      "DeleteCatalogItem": "Supprimer un poste",
      "DeleteCatalogItemText": "Faut-il vraiment supprimer ce poste ?",
      "EditCatalogItem": "Modifier le poste",
      "EditCatalogView": "Modifier l'affichage du catalogue",
      "ExportComparisonBaseValidDate": "Date de base",
      "ExportComparisonCompareValidDate": "Date de comparaison",
      "ExportDialogText": "Veuillez saisir la date de validité souhaitée pour l’export. Vous pouvez\négalement supprimer la date pour exporter tous les enregistrements.",
      "ExportValidDate": "Date de validité",
      "HistoryTitle": "Historique de l'entrée \"{{uid}}\"",
      "Import": {
        "Added": "Ajouté",
        "CurrentFile": "Fichier actuel",
        "DropExcelToAttach": "Déposer le fichier Excel ici ou ",
        "DropExcelToAttachLink": "parcourir",
        "ErrorCodes": {
          "HeaderRowNotFound": "En-tête non trouvé",
          "InvalidHeaderStructure": "Structure de colonne non valide",
          "NoWorksheetFound": "Aucune feuille de calcul trouvée dans le fichier Excel",
          "ProcessingFailed": "Échec du traitement",
          "UnexpectedError": "Erreur inattendue"
        },
        "ErrorsLabel": "Erreur",
        "ImportCompletedSuccessfully": "Importation réussie",
        "ImportCompletedWithErrors": "Importation terminée avec des erreurs",
        "ImportExcel": "Importation Excel",
        "ImportStart": "Démarrer l'importation",
        "Imported": "Importe",
        "Importing": "Importer",
        "OverwriteExistingItems": "Remplacer directement des entrées de catalogue existantes (sans historique)",
        "RowsProcessed": "Entrées de catalogue traitées",
        "Skipped": "Sauté",
        "Status": {
          "Completed": "Importation terminée",
          "Failed": "Échec de l'importation",
          "Initializing": "Initialisation de l'importation...",
          "Processing": "{{count}} Lignes en cours de traitement",
          "Saving": "Les modifications sont enregistrées dans la base de données",
          "Starting": "L'importation démarre...",
          "Unknown": "Statut inconnu"
        },
        "TotalRows": "Total des inscriptions au catalogue",
        "Updated": "Actualisé"
      },
      "ShowHistory": "Afficher l'historique"
    }
  },
  "Contract": {
    "AddContract": "Ajouter un contrat",
    "AddressHeader": "Adresse",
    "CashingFeeAppliedToOkp": "Taxe sur l'AOS",
    "CashingFeeAppliedToOkpTooltip": "Si 'Non', la taxe ne sera prélevée que sur la part LCA.",
    "CompensationType": {
      "Factor": "Facteur",
      "FixedPrice": "Tarif fixe",
      "TaxPointValue": "Valeur du point tarifaire"
    },
    "DefaultTerminationDateExpressionHeader": "Date de résiliation règle",
    "DeleteContract": "Supprimer le contrat",
    "DeleteContractText": "voulez-vous vraiment supprimer ce contrat ?",
    "EditContract": "modifier le contrat",
    "EditFinalContract": "Traiter un contrat actif",
    "EditFinalContractDialogText": "Ce contrat a déjà été validé. Les modifications ne sont pas appliquées aux contrats individuels déjà conclus. Veuillez saisir une justification pour la modification apportée au contrat-cadre actif.",
    "EditFinalContractReasonLabel": "Justification",
    "Errors": {
      "Factor": "Ce champ doit être renseigné, sa valeur doit être au moins égale à 0 et ne doit pas comporter plus de 4 décimales.",
      "InsuranceRequiredForNonInvoiceOnlyContracts": "Une assurance doit être sélectionnée si le contrat n'est pas de type 'Uniquement pour Invoice'.",
      "InsuranceRequiredWhenFactorSet": "Une assurance doit être sélectionnée si le facteur P1 ou P2 est activé.",
      "OkpFactorRequiredWithoutInsurance": "Le facteur AOS doit être supérieur à 0 si aucune assurance n'est sélectionnée.",
      "SecondaryCatalogViewMustDifferFromCatalogViewId": "Veuillez sélectionner un catalogue secondaire qui diffère du catalogue.",
      "SecondaryCatalogViewWithoutCatalogView": "Choisissez d'abord un catalogue.",
      "TertiaryCatalogViewMustDifferFromOtherCatalogViews": "Veuillez sélectionner un catalogue tertiaire qui soit différent du catalogue principal et du catalogue secondaire.",
      "TertiaryCatalogViewWithoutSecondaryCatalogView": "Commencez par sélectionner un catalogue secondaire.",
      "TitleAlreadyExists": "Un contrat portant ce titre existe déjà.",
      "TitleRequired": "Le titre doit être complété."
    },
    "ExcludeOkpFactorPositionSpecific": "Exclure le facteur AOS de manière spécifique à la position",
    "ExcludeOkpFactorPositionSpecificTooltip": "S'il est activé, le facteur AOS est exclu pour les positions qui sont prévues à cet effet. Le calcul ne prend alors en compte que le facteur LCA et le facteur individuel.",
    "ExtendContract": "Prolonger le contrat",
    "ExtendContractDialog": {
      "Text": "Le contrat-cadre et tous les contrats individuels encore actifs sont prolongés à la nouvelle date.",
      "Title": "Prolonger le contrat",
      "ValidUntilLabel": "Nouveau Date de fin de validité"
    },
    "FinalizeContractDraft": "Valider le contrat",
    "FinalizeContractDraftConfirmationText": "Voulez-vous valider le contrat ?",
    "Header": "Contrats-cadres",
    "InstitutionFactorsHint": "L'institution a déposé des facteurs AOS spécifiques.",
    "InstitutionGroupWarning": "Cette clinique peut être gérée de manière autonome par le groupe hospitalier «{{institutionGroupName}}». Veuillez convenir des modifications à apporter au contrat.",
    "InvoiceReceivers": "Destinataire de la facture",
    "InvoiceReceiversTooltip": "Dès qu'un destinataire de facture est attribué, la sélection est proposée lors de l'établissement de la facture. Sans sélection, le destinataire de la facture de l'institution est forcé.",
    "InvoicingFeeRates": {
      "AddRate": "Ajouter des frais",
      "CurrentRate": "{{percentage}} %",
      "CurrentRateWithScheduled": "{{percentage}} % → à partir de {{scheduledPercentage}} % {{scheduledValidFrom}}",
      "DeleteRate": "Supprimer",
      "Errors": {
        "NotUnique": "Une seule redevance peut être saisie par date « Valable à partir du »."
      },
      "Hint": "Pour une facture, c'est le tarif en vigueur à la date d'« hospitalisation » indiquée sur la facture qui s'applique. Les factures déjà établies conservent toujours le tarif qui leur était applicable.",
      "Percentage": "Taux (%)"
    },
    "IsDraft": {
      "Draft": "Projet",
      "Final": "Actif"
    },
    "IsForSpecialistsOnly": "Réservé aux médecins spécialistes",
    "IsForSpecialistsOnlyTooltip": "Si activé, le contrat ne peut être utilisé que par des médecins spécialistes.",
    "NoInvoiceReceiverOption": "Pas de destinataire de facture électronique",
    "NoInvoiceReceiverOptionTooltip": "Seulement si activé, il est possible de sélectionner 'Pas de destinataire de facture électronique' lors de la création de la facture.",
    "OfferValidityManagedExternally": "Les paramètres des offres sont gérés dans Contracto Insurance.",
    "OfferValidityWeeksValue": "Validité de l'offre : {{weeks}} semaines.",
    "ParentContractHeader": "Contrat de niveau supérieur",
    "Pdf": {
      "Pdf02Title": "Complément 1",
      "Pdf02TitleLabel": "Supplément 1 (facultatif)",
      "Pdf03Title": "Complément 2",
      "Pdf03TitleLabel": "Supplément 2 (facultatif)",
      "PdfTitle": "Contrat"
    },
    "SaveDraft": "Enregistrer le projet",
    "SecondaryCatalogView": "Catalogue secondaire",
    "SecondaryCatalogViewTooltip": "Si cette option est activée, le catalogue est disponible en tant que deuxième catalogue lors de la facturation.",
    "SignatureHeader": "Signature",
    "StartPhaseEndValue": "Phase de lancement jusqu'à {{date}}.",
    "Status": {
      "Active": "Actif",
      "ContractWasValidUntil": "Le contrat était valable jusqu'au {{validUntilDate}}.",
      "Denied": "Refusé",
      "InProcessing": "En cours de traitement",
      "OfferDeadline": "Offre valable jusqu'au {{offerDeadlineDate}}.",
      "Replaced": "Remplacé",
      "Terminated": "Résilié",
      "TerminatedDate": "A été résilié le {{terminatedDate}}{{terminatedBy}}.",
      "UserConfirmationPending": "Confirmation par l'utilisateur ouverte",
      "UserConfirmationPendingInSentence": "Confirmation par l'utilisateur en attente.",
      "UserDeclined": "Offre refusée"
    },
    "TerminationType": {
      "AutomaticallyTerminated": "Résilié automatiquement",
      "AutomaticallyTerminatedInSentence": " automatique",
      "TerminatedByInsurance": "Résilié par l'assurance",
      "TerminatedByInsuranceInSentence": " par l'assurance",
      "TerminatedByUser": "Résilié par l'utilisateur",
      "TerminatedByUserInSentence": " par l'utilisateur",
      "Title": "Type de résiliation"
    },
    "TertiaryCatalogView": "Catalogue tertiaire",
    "TertiaryCatalogViewTooltip": "Si cette option est activée, le catalogue est disponible en tant que troisième catalogue lors de la facturation.",
    "Type": {
      "InvoiceOnly": "Uniquement pour Invoice",
      "Standard": "Standard",
      "UserMustConfirm": "Confirmation de l'utilisateur"
    },
    "TypeLabel": "Type",
    "ValidFromEmptyHint": "Pour les contrats individuels, la date du jour est utilisée comme date de début par défaut.",
    "ValidFromOpen": "Sans date de début",
    "ValidUntilChangeWarning": "Attention : en cas de modification de la date \"Valable jusqu'au\", les contrats individuels ne sont pas automatiquement adaptés. Utilisez la fonction \"Prolonger le contrat\" pour mettre à jour également les contrats individuels.",
    "ValidUntilUnlimited": "CDI",
    "WithdrawalPeriodHeader": "Délai de rétractation"
  },
  "Dashboard": {
    "InfoText": "<h4>Exemple de texte</h4>"
  },
  "DataTable": {
    "AddRowTitle": "Ajouter un enregistrement",
    "DeleteRowText": "voulez-vous vraiment supprimer cet enregistrement ?",
    "DeleteRowTitle": "Supprimer l'enregistrement",
    "EditRowTitle": "Modifier l'enregistrement"
  },
  "Dialog": {
    "AcceptTermsDialog": {
      "AcceptTermsCheckboxText": "J'accepte les conditions d'utilisation"
    },
    "EditEmployeeContainerComponent": {
      "ZSRNumberHint": "Vous pouvez rechercher le numéro RCC <a href=\"{{zsrUrl}}\" target=\"_blank\">ici.</a>"
    },
    "EditInvoiceContainerComponent": {
      "CaseNumber": "Numéro de cas",
      "CaseNumberPlaceholder": "par ex. 1549876127",
      "PIDOptional": "PID (facultatif)"
    },
    "EditInvoiceInsuranceContainerComponent": {
      "FactorsCannotBeChanged": "Les facteurs ne peuvent pas être modifiés pour ce type de contrat.",
      "FactorsDifferently": "Différents facteurs dans des contrats sélectionnés.",
      "FieldWillBeChanged": "Ce champ est adapté pour tous les contrats sélectionnés.",
      "FieldWillNotBeChanged": "Ce champ n'est pas adapté.",
      "NoBaseFactor": "Facteur non disponible dans le contrat de base."
    },
    "EditInvoiceSessionContainerComponent": {
      "Errors": {
        "ManualValueRequired": "Veuillez saisir une valeur pour la puissance {{positionNumbers}}.",
        "SessionDateRequired": "La date de la séance doit être remplie."
      },
      "MostUsedPositions": "Fréquemment utilisé",
      "Performances": "Prestations",
      "RemoveServiceProvider": "Supprimer {{ serviceProviderDisplay }} comme prestataire de services",
      "SelectedPerformances": "Services sélectionnés",
      "SelectedSurcharges": "Suppléments sélectionnés",
      "SessionDate": "Date de la séance",
      "SetMainItem": "Mettre comme prestation principale",
      "SetServiceProvider": "Définir un prestataire différent",
      "ShowAllPositions": "Tout afficher",
      "Suggestions": "Des services adaptés",
      "Surcharges": "Suppléments"
    },
    "EditPositionServiceProvider": {
      "ServiceProvidersInSession": "Prestataires déjà utilisés"
    },
    "FileUploadDialog": {
      "Errors": {
        "RequestTooLargeText": "Le(s) fichier(s) sélectionné(s) dépasse(nt) la limite de téléchargement de fichiers. Si vous téléchargez plusieurs fichiers, vous pouvez essayer de les télécharger un par un.",
        "RequestTooLargeTitle": "Limite de fichiers atteinte"
      },
      "Files": "Fichiers",
      "OrDropHere": "Ou les déposer ici par glisser-déposer.",
      "SaveSecure": "Télécharger des fichiers dans un espace de stockage sécurisé. (Ne peut être téléchargé qu'avec un login)",
      "SelectFiles": "Sélectionner des fichiers",
      "ShouldOverwriteFiles": "Les fichiers doivent-ils être écrasés ?",
      "Title": "Télécharger des fichiers",
      "Upload": "Télécharger"
    },
    "InfoLinkDialog": {
      "Errors": {
        "LinkRequired": "Le lien doit être complété.",
        "RequestTooLargeText": "Le fichier sélectionné dépasse la limite de téléchargement de fichiers.",
        "RequestTooLargeTitle": "Limite de fichiers atteinte"
      },
      "File": "Fichier",
      "OrDropHere": "Ou les déposer ici par Drag & Drop.",
      "SelectFile": "Sélectionner un fichier",
      "Title": "Lien d'information",
      "Upload": "Ajouter un lien d'information"
    },
    "ServiceTypeConfigDialogComponent": {
      "ServiceProvider": "Fournisseur de prestations (différent de l'auteur de la facture)",
      "ServiceProviderType": "Catégorie de médecins",
      "ServiceProviderTypeRequired": "Veuillez sélectionner une catégorie",
      "ServiceType": "Type",
      "Title": "Choisir les types de prestations"
    },
    "SmsVerificationDialog": {
      "Title": "Confirmation par SMS"
    }
  },
  "Email": {
    "Columns": {
      "CC": "CC",
      "CreateDate": "Créé",
      "ErrorCounter": "Nombre d'erreurs",
      "From": "De",
      "Priority": "Priorité",
      "SendDate": "Envoyé à",
      "Status": "Statut",
      "Subject": "Sujet",
      "To": "À"
    },
    "Status": {
      "Error": "Erreur lors de l'envoi",
      "Pending": "Dans la file d'attente",
      "Sending": "envoi en cours",
      "Sent": "Envoyé"
    }
  },
  "Employee": {
    "Errors": {
      "GlnRequired": "Veuillez saisir le numéro GLN.",
      "OnlyNaturalPersons": "Seules les personnes physiques peuvent être créées comme collaborateurs.",
      "SaveAnyways": "voulez-vous quand même enregistrer ?"
    },
    "Management": {
      "AddAssistant": "Ajouter un assistant",
      "AddEmployee": "Ajouter un médecin",
      "EditEmployee": "Modifier le médecin",
      "FilterContractToDo": "N'afficher que les entrées sans contrat ou avec confirmation ouverte"
    },
    "Search": {
      "Hint": "Veuillez sélectionner un médecin (personne physique) sur <a href=\"https://www.refdata.ch/de/partner/abfrage/partner-refdatabase-gln\" target=\"_blank\">Refdata</a> en recherchant ici par GLN ou nom de famille :",
      "NoResults": "Aucun résultat trouvé",
      "Results": "Résultats de la recherche",
      "SearchBy": "Rechercher",
      "SearchTermGln": "GLN",
      "SearchTermLastName": "Nom de famille",
      "Title": "Choisir un médecin"
    }
  },
  "ErrorHandler": {
    "BackendOfflineErrorText": "Le serveur est actuellement indisponible. Veuillez réessayer plus tard ou contacter votre administrateur.",
    "BackendOfflineErrorTitle": "Serveur indisponible",
    "BadRequestTitle": "Erreur",
    "ForbiddenText": "Vous n'êtes pas éligible pour ce module.",
    "ForbiddenTitle": "Non autorisé",
    "InternalServerErrorDevTitle": "Erreur dans l'API",
    "InternalServerErrorProdText": "Une erreur inattendue s'est produite. Si le problème persiste, veuillez contacter votre administrateur.",
    "InternalServerErrorProdTitle": "Erreur inattendue",
    "ReloadApplication": "Recharger l'application",
    "SessionExpiredText": "Votre session a expiré. Veuillez vous reconnecter.",
    "SessionExpiredTitle": "La session a expiré",
    "TooManyRequestsErrorText": "Trop de demandes ont été envoyées en peu de temps. Veuillez réessayer dans {{retryAfter}} secondes.",
    "TooManyRequestsErrorTitle": "Trop de demandes",
    "UserLockoutText": "L'accès à l'application est bloqué ou n'a pas encore été débloqué.",
    "UserLockoutTitle": "Utilisateur bloqué",
    "WarningTitle": "Avertissement"
  },
  "Favorites": {
    "AddToFavorites": "Ajouter aux favoris",
    "All": "Tous les favoris",
    "DefaultFolder": "Favoris",
    "DialogTitle": "Enregistrer comme favori",
    "Folder": "Dossier",
    "NewFolder": "Nouveau dossier",
    "RemoveFromFavorites": "Supprimer des favoris",
    "Title": "Favoris"
  },
  "Global": {
    "AccountType": "Type de compte",
    "ActiveFrom": "Actif depuis",
    "ActiveUntil": "Actif jusqu'à",
    "All": "Tous",
    "ApplicationUpdateAvailable": "Une nouvelle version du site est disponible. Veuillez cliquer sur Ok pour recharger la page.",
    "ApplicationUpdateAvailableTitle": "Nouvelle version disponible",
    "ApprovalReason": {
      "DelegateUserType": "Automatisé sur la base de la classe d'utilisateurs Délégation",
      "ExternalInstitutionData": "Automatisé via la comparaison des données institutionnelles"
    },
    "ApprovedBy": "Débloqué par",
    "ApprovedDate": "Activé le",
    "Assistant": "Assistant",
    "BESR": "Référence QR",
    "BackToLoginButton": "Retour à la connexion",
    "BankAccount": "Coordonnées bancaires",
    "BankAccountIban": "IBAN",
    "BankAccountIbanOrQrIban": "IBAN / QR-IBAN",
    "BankAccountIbanTooltip": "Lors de la facturation, un QR-IBAN est nécessaire pour certains destinataires de factures.",
    "BankAccountQrIban": "QR-IBAN",
    "Cancel": "Annuler",
    "Canton": "Canton",
    "CaseNumber": "Numéro de cas",
    "Catalog": "Catalogue",
    "CatalogItems": "Catalogue des positions",
    "CatalogView": "Vue du catalogue",
    "CatalogViews": "Vue des catalogues",
    "Choose": "Choisir",
    "City": "Lieu",
    "ClearFilter": "Supprimer le filtre",
    "Close": "Fermer",
    "CloseDialog": "Fermer le dialogue",
    "CompensationType": "Type de rémunération",
    "Contract": "Contrat",
    "ContractContactInformation": "Coordonnées",
    "ContractContactInformationHeader": "Contact",
    "ContractContactInformationTooltip": "Afficher les informations de contact",
    "ContractContent": "Contenu du contrat",
    "ContractDoctors": "Médecins conventionnés",
    "Contracts": "Contrats",
    "ControllingForInvoiceReceiver": "Invoice Controlling pour les destinataires de factures",
    "ControllingForInvoiceReceiverInfo": "L'utilisateur peut consulter, confirmer et rejeter les factures des destinataires de factures sélectionnés.",
    "Copy": "Copier",
    "Count": "Nombre",
    "CreatedBy": "Saisi par",
    "CsvExport": "CSV-Export",
    "Date": "Date",
    "DateOfBirth": "Date de naissance",
    "DeclineReason": "Motif de refus",
    "Decrease": "Diminuer",
    "Delegations": "Délégation",
    "Delete": "Supprimer",
    "Description": "Description",
    "Details": "Détails",
    "DontShowAgain": "Ne plus afficher",
    "Draft": "Projet",
    "EMail": "E-Mail",
    "Edit": "Modifier",
    "EmailConfirmed": "E-mail confirmé",
    "EmployedFrom": "Employé par",
    "EmployedUntil": "Employé(e) jusqu'au",
    "Employee": "Liste des médecins",
    "EmployeeGroups": "Listes de médecins",
    "Enlarge": "Agrandir",
    "Errors": {
      "BankAccountIbanInvalid": "Veuillez saisir un IBAN valide.",
      "DateIsRequired": "Veuillez compléter la date.",
      "FieldIsRequired": "Veuillez compléter ce champ.",
      "GlnInvalid": "Le GLN n'est pas valide.",
      "GlnLength": "Le GLN doit être composé de 13 chiffres.",
      "GlnPatternInvalid": "Format non valide du GLN.",
      "GlnRequired": "Le GLN doit être rempli.",
      "GlnServiceUnavailable": "Le GLN n'a pas pu être vérifié, car le service de vérification n'est actuellement pas accessible.",
      "InvalidDate": "Date non valide.",
      "LoadFailed": "Les données n'ont pas pu être chargées.",
      "MaxLength": "Veuillez utiliser au maximum {{limit}} caractères",
      "MobilePhoneNumberPattern": "Saisir le numéro au format +41XXXXXXXX.",
      "MobilePhoneNumberRequired": "Le numéro de portable est nécessaire.",
      "PostalCodeInvalid": "Veuillez saisir un code postal numérique",
      "PostalCodeRequired": "Veuillez saisir un code postal.",
      "QrReferencePrefixInvalid": "La valeur doit être numérique",
      "SaveFailed": "Échec de l'enregistrement.",
      "TextIsRequired": "Veuillez compléter le texte.",
      "TextTooShort": "Veuillez saisir plus de texte.",
      "ValidFromMustBeBeforeValidUntil": "La date doit être antérieure à la date de fin de validité.",
      "ValidFromRequired": "Veuillez indiquer la date de début de validité.",
      "ValidUntilMustBeAfterValidFrom": "La date doit être postérieure à la date de fin de validité.",
      "ZsrNumberInvalid": "Format du numéro RCC non valide."
    },
    "Evaluation": "Évaluation",
    "ExcelExport": "Export Excel",
    "ExcelExportComparison": "Comparaison des exports Excel",
    "Factor": "Facteur",
    "FactorP1": "Privé",
    "FactorP2": "Demi-privé",
    "FirstName": "Prénom",
    "For": "pour",
    "Frequency": "Fréquence",
    "FunctionTitle": "Titre de spécialiste",
    "Gender": "Sexe",
    "GenderFemale": "femme",
    "GenderMale": "masculin",
    "Gln": "GLN",
    "GlnHint": "Vous pouvez rechercher le GLN <a href=\"https://www.refdata.ch/fr/partenaires/requete/base-de-donnees-des-partenaires-gln\" target=\"_blank\"> ici.</a>",
    "Groups": "Groupes",
    "GuestAssistant": "Assistant invité",
    "GuestDoctor": "Médecin invité",
    "GuestDoctors": "Médecins invités",
    "HospitalizationFrom": "Hospitalisation de",
    "HospitalizationUntil": "Hospitalisation jusqu'au",
    "Id": "Id",
    "Identifier": "Identifiant ",
    "Increase": "Augmenter",
    "IndividualFactor": "Facteur individuel",
    "IndividualFactorShort": "Facteur ind.",
    "Info": "Info",
    "InfoLinks": "Liens d'information",
    "Institution": "Institution",
    "InstitutionClinic": "Institution/clinique",
    "InstitutionPractice": "Nom du cabinet / de l'institut",
    "Institutions": "Institutions",
    "Insurance": "Assurance",
    "InsuranceType": "Type d'assurance",
    "InsuranceTypeGeneral": "Généralités",
    "InsuranceTypePrivate": "Privé",
    "InsuranceTypeSemiPrivate": "Demi-privé",
    "Insurances": "Assurances",
    "Invoice": "Facture",
    "InvoiceDate": "Date de la facture",
    "InvoiceReceiver": "Destinataire de la facture",
    "InvoiceReceiverSettingsButton": "Réglages pour {{invoiceReceiverTitle}}",
    "InvoiceReceiverSettingsHint": "Paramètres des destinataires de factures pour cet utilisateur. Pertinent uniquement si l'utilisateur utilise ce destinataire pour les factures.",
    "InvoiceReceivers": "Destinataire de la facture",
    "Invoices": "Factures",
    "InvoicingFee": "frais",
    "InvoicingZsrNumber": "RCC n° pour le décompte",
    "InvoicingZsrNumberHint": "<b>Veuillez saisir un RCC différent (RCC du cabinet) si vous ne facturez pas avec votre RCC personnel.<br>Les numéros K (6 chiffres + lettre) ne sont pas autorisés.</b><br>Vous pouvez rechercher le n° de RCC <a href=\"{{zsrUrl}}\" target=\"_blank\">ici.</a>",
    "KeyboardHints": {
      "ArrowKeysSelect": "↑↓ sélectionner",
      "EnterApply": "Appuyer sur Entrée pour valider",
      "EscClose": "Appuyer sur Échap pour fermer"
    },
    "Kind": "Type",
    "Language": "Langue",
    "LastChange": "Dernière modification",
    "LastLogin": "Dernière connexion",
    "LastName": "Nom de famille",
    "MainPerformance": "Prestation principale",
    "MainServiceProvider": "Prestataire principal",
    "Memo": "Mémo",
    "MobilePhoneNumber": "N° de portable",
    "Name": "Nom",
    "No": "Non",
    "NoResults": "Aucun résultat trouvé",
    "Nr": "N°",
    "Number": "Numéro",
    "OKPFactor": "Facteur AOS",
    "ObjectPermissions": "Objets autorisés ",
    "Ok": "Ok",
    "OverallFactorP1": "Total privé",
    "OverallFactorP2": "Total demi-privé",
    "PID": "PID",
    "Password": "Mot de passe",
    "PatientID": "ID du patient",
    "PdfExport": "Export Pdf",
    "PhoneNumber": "Numéro de téléphone",
    "PleaseSelect": "Veuillez choisir",
    "PositionValue": "Valeur de la position",
    "PostalCode": "CODE POSTAL",
    "Refresh": "Actualiser",
    "Remove": "Supprimer",
    "ResultCount": {
      "Plural": "Résultats",
      "Singular": "Résultat"
    },
    "Retry": "Réessayer",
    "Roles": "Rouleaux",
    "Save": "Enregistrer",
    "SaveAnyway": "Enregistrer quand même",
    "Search": "Recherche",
    "Select": "Choisir",
    "SelectAll": "Tout sélectionner ",
    "SelectDateRange": "Sélectionner la plage de dates",
    "SelectedCount": "{{count}} sélectionné",
    "SentAt": "Envoyé le",
    "ServiceProvider": "Fournisseur de prestations",
    "ServiceText": "Texte de la prestation",
    "Sessions": "Séances",
    "ShowDetails": "Afficher les détails",
    "ShowLess": "afficher moins",
    "ShowMore": "tout afficher",
    "Shrink": "Réduire",
    "Specialist": "Médecin spécialiste",
    "SpecialistHint": "Les utilisateurs marqués 'Spécialiste' peuvent utiliser des contrats-cadres destinés uniquement aux médecins spécialistes.",
    "State": "Statut",
    "Street": "Rue",
    "SubTotalTaxPoints": "Sous-total des points tarifaires",
    "Surcharge": "Supplément",
    "SurchargeFactor": "Facteur Supplémentaire",
    "Title": "Titre",
    "Total": "Total",
    "TotalTaxPoints": "Total des points tarifaires",
    "TreatmentDate": "Date du traitement",
    "Type": "Type",
    "TypeHereToSearch": "Tapez ici pour rechercher",
    "Unknown": "Inconnu",
    "UsedAs": "Utilisé comme",
    "User": "Utilisateur",
    "UserContracts": "Utilisateurs contrats",
    "UserInfo": "Infos utilisateur",
    "UserName": "Nom d'utilisateur",
    "UserType": "Catégorie d'utilisateurs",
    "VVGFactorP1": "LCA privé",
    "VVGFactorP1WithCompensationType": "LCA {{compensationType}} privé",
    "VVGFactorP2": "LCA demi-privée",
    "VVGFactorP2WithCompensationType": "LCA {{compensationType}} demi-privé",
    "ValidFrom": "Valable du",
    "ValidFromOnActivation": "à compter de l'activation",
    "ValidPermanent": "Durée indéterminée",
    "ValidUntil": "Valable jusqu'au",
    "Valuation": "Évaluation",
    "Value": "Valeur",
    "Visit": "Visite",
    "WithoutGroup": "Sans groupe",
    "WithoutInstitution": "Sans institution",
    "Yes": "Oui",
    "ZsrNumber": "No RCC "
  },
  "Home": {
    "BrowserModal": {
      "ButtonText": "Utiliser le site web quand même",
      "Text": "Le navigateur '{{browserName}}' n'est plus officiellement pris en charge.<br><br> Ce navigateur ne vous permet pas d'utiliser toutes les fonctions de ce site.",
      "Title": "Navigateur non pris en charge"
    },
    "ForgotPasswordButton": "Demander un nouveau mot de passe",
    "ForgotPasswordInfo": "Si vous êtes déjà inscrit et que vous avez oublié votre mot de passe, vous pouvez demander un nouveau mot de passe ici.",
    "Info": "<ul><li>En tant que nouvel utilisateur, vous devez d'abord vous enregistrer (nouvelle inscription).</li><li style=\"margin-bottom:10px;\"> Votre inscription sera vérifiée et vous recevrez un e-mail dès que vous pourrez utiliser le site.</li><li> Votre nom d'utilisateur est l'adresse e-mail avec laquelle vous vous êtes enregistré.</li><li> Après vous être connecté, vous arrivez sur la page d'accueil de l'intranet de Medicalculis </li><li> De là, vous pouvez naviguer vers les évaluations de prestations et les contrats.</li></ul>",
    "Login": {
      "EmailPassword": "Connexion par e-mail et mot de passe",
      "HIN": "Connexion via HIN"
    },
    "RegisterButton": "Nouvelle inscription",
    "Title": "Intranet Medicalculis"
  },
  "IndividualCompensation": {
    "AddIndividualCompensation": "Ajouter un facteur",
    "DeleteIndividualCompensation": "Supprimer",
    "Errors": {
      "NotUnique": "Le facteur individuel doit être unique."
    },
    "Header": "Facteurs",
    "IsDefault": "Sélection standard",
    "Reference": "Groupe de fournisseurs de prestations"
  },
  "Info": {
    "AddInfoLink": "Ajouter un lien d'information",
    "DeleteInfoLink": "Supprimer le lien d'information",
    "DeleteInfoLinkText": "Faut-il vraiment supprimer ce lien d'information ?",
    "EditInfoLink": "Modifier le lien d'information",
    "EditInfoLinks": "Info Modifier les liens",
    "GeneralInfoLinks": "Généralités",
    "Header": "Info",
    "InstitutionSpecificInfoLinks": "Propre à chaque établissement",
    "InstitutionsForPhysician": "Limiter la visibilité aux médecins agréés des institutions suivantes :",
    "InstitutionsWithoutGroup": "Sans groupe hospitalier",
    "InsurancesForUserClass": "Limiter la visibilité aux utilisateurs des assurances suivantes :",
    "IsPublic": "Visible par tous les utilisateurs",
    "LinkAction": {
      "DownloadFile": "Télécharger le fichier",
      "OpenInNewTab": "Ouvrir le lien non protégé dans un nouvel onglet",
      "OpenPdf": "Ouvrir le PDF protégé dans un nouvel onglet",
      "OpenPdfDialog": "Ouvrir le PDF dans le dialogue"
    },
    "LinkActionHeader": "Action de liens",
    "LinkHeader": "Lien",
    "Order": "Ordre",
    "UploadFiles": "Télécharger des fichiers",
    "UserGroupPermissionHint": "La visibilité des liens peut en outre être réglée via les groupes.",
    "Visibility": "Visibilité"
  },
  "Institution": {
    "AddInstitution": "Ajouter une institution",
    "Cantons": {
      "Ag": "Argovie",
      "Ai": "Appenzell Rhodes-Intérieures",
      "Ar": "Appenzell Rhodes-Extérieures",
      "Be": "Berne",
      "Bl": "Bâle-Campagne",
      "Bs": "Bâle-Ville",
      "Fr": "Fribourg",
      "Ge": "Genève",
      "Gl": "Glaris",
      "Gr": "Grisons",
      "Ju": "Jura",
      "Lu": "Lucerne",
      "Ne": "Neuchâtel",
      "Nw": "Nidwald",
      "Ow": "Obwald",
      "Sg": "Saint-Gall",
      "Sh": "Schaffhouse",
      "So": "Soleure",
      "Sz": "Schwyz",
      "Tg": "Thurgovie",
      "Ti": "Tessin",
      "Ur": "Uri",
      "Vd": "Vaud",
      "Vs": "Valais",
      "Zg": "Zoug",
      "Zh": "Zurich"
    },
    "CaseNumberRequired": "Le numéro de cas est obligatoire",
    "DeleteInstitution": "Supprimer une institution",
    "DeleteInstitutionText": "Faut-il vraiment supprimer cette institution ?",
    "EditInstitution": "Modifier l'institution",
    "Errors": {
      "CantonFormat": "Le canton doit être rempli (pour l'échange de données du forum)",
      "TitleRequired": "Le titre doit être complété.",
      "ZsrFormat": "Le RCC doit être composé d'une lettre suivie de six chiffres."
    },
    "Factors": {
      "AddFactor": "Ajouter un facteur",
      "ClearValidUntil": "Supprimer jusqu'au",
      "Columns": {
        "ExternalCode": "Externe",
        "MedRegCode": "MedReg",
        "OkpFactor": "AOS",
        "Qualification": "Groupe spécialisé"
      },
      "ConfirmDelete": "Supprimer vraiment ce facteur ?",
      "DeleteFactor": "Supprimer le facteur",
      "Description": "Ces facteurs sont appliqués indépendamment du contrat si le fournisseur de prestations possède le titre de spécialisation validé correspondant.",
      "EditFactor": "Traiter le facteur",
      "EditValidUntil": "Valable jusqu'à modifier - {{qualification}}",
      "Errors": {
        "OkpFactorBoundaries": "Le facteur AOS doit se situer entre {{min}} et {{max}} .",
        "OverlappingFactor": "Le facteur chevauche un facteur existant.",
        "ValidUntilMustBeAfterValidFrom": "La date de fin de validité doit être postérieure à la date de début de validité."
      },
      "FactorInUse": "Ce facteur a déjà été utilisé (la dernière fois le {{date}}) et ne peut plus être édité.",
      "FactorInUseValidUntilOnly": "Dernière utilisation le {{date}} - seul \"Valable jusqu'au\" peut encore être modifié.",
      "FilterByQualification": "Filtrer par groupe de disciplines",
      "ManageButton": "Gérer les facteurs institutionnels",
      "NewFactor": "Nouveau facteur",
      "ResultCount": {
        "All": {
          "Plural": "Facteurs",
          "Singular": "Facteur"
        },
        "CurrentlyValid": {
          "Plural": "facteurs valables aujourd'hui",
          "Singular": "facteur valable aujourd'hui"
        }
      },
      "SelectQualification": "Sélectionner un groupe de disciplines",
      "ShowAll": "Tout afficher",
      "ShowOnlyCurrentlyValid": "N'afficher que ceux qui sont actuellement valables",
      "Title": "Facteurs institutionnels"
    },
    "GlnEmptyHint": "Pour les institutions, il convient d'indiquer un GLN. Ne laissez ce champ vide que dans des cas exceptionnels dûment justifiés.",
    "Header": "Institutions",
    "InstitutionGroup": "Groupe de cliniques",
    "InstitutionGroupAdmin": "Administrateur pour un groupe d'établissements hospitaliers",
    "InstitutionGroupDetails": "Détails du groupe",
    "InstitutionGroupIdentityProvider": "Fournisseur d'identité",
    "InstitutionGroupSubDomain": "Sous-domaine",
    "InstitutionGroupTooltip": "Détermine à quel groupe hospitalier appartient l'établissement. Les administrateurs de ce groupe hospitalier peuvent gérer ses utilisateurs. De plus, lors de l'inscription, l'établissement apparaît sous le sous-domaine correspondant.",
    "InstitutionGroupUserDomain": "Domaine d'utilisateur",
    "InvoiceReceiverCopyOnly": "(copie seulement)",
    "InvoiceReceiverTooltip": "L'envoi au destinataire est forcé si le contrat n'est pas configuré différemment"
  },
  "Insurance": {
    "AddInsurance": "Ajouter une assurance",
    "DeleteInsurance": "Supprimer l'assurance",
    "DeleteInsuranceText": "Faut-il vraiment supprimer cette assurance ?",
    "EditInsurance": "Modifier l'assurance",
    "Errors": {
      "TitleRequired": "Le titre doit être complété."
    },
    "GlnEmptyHint": "Sans numéro GLN, cette assurance ne peut pas être utilisée pour les factures.",
    "Header": "Assurances",
    "ParentInsurance": "Représenté par",
    "PendingUserContracts": {
      "AcceptContractsDialogText": "Veuillez confirmer que vous souhaitez accepter/proposer les contrats sélectionnés.",
      "AcceptContractsDialogTitle": "Accepter/offrir des contrats",
      "AcceptSelected": "Accepter/proposer les objets sélectionnés",
      "CannotEditFactorsHint": "Vous avez sélectionné des contrats avec différents contrats de base ou différents types de contrats, les facteurs ne peuvent donc pas être modifiés.<br>Les facteurs ne peuvent être modifiés que pour les contrats qui doivent être confirmés par l'utilisateur.",
      "DeclineContractsDialogText": "Veuillez confirmer que vous souhaitez refuser les contrats sélectionnés.",
      "DeclineContractsDialogTitle": "Refuser des contrats",
      "DeclineSelected": "Refuser les objets sélectionnés",
      "EditAndAcceptSelected": "Modifier et accepter/proposer les objets sélectionnés",
      "EditUserContract": "Modifier le contrat",
      "Header": "Contrats ouverts"
    },
    "PhysicianSearchHirslanden": "Recherche de médecins Hirslanden",
    "UserContracts": {
      "ContractChangesExcelReport": "Comparaison des exports Excel",
      "Header": "Contrats",
      "SelectTerminationDateDialog": {
        "AdditionalTextLabel": "Justification (sera envoyée par e-mail)",
        "TerminationDateLabel": "Résilier pour le (date)",
        "Title": "Résilier un contrat",
        "VariousTerminationDatesHint": "Tous les contrats n'ont pas la même date de résiliation par défaut. Si vous saisissez une date ici, la date de résiliation sélectionnée sera utilisée pour tous les contrats."
      },
      "TerminateContractsDialogText": "Veuillez confirmer que vous souhaitez résilier les contrats sélectionnés.",
      "TerminateContractsDialogTitle": "Résilier des contrats",
      "TerminateSelected": "résiliations sélectionnées"
    }
  },
  "Invoice": {
    "AcceptTermsDialog": {
      "Text": "Veuillez accepter les conditions d'utilisation pour pouvoir utiliser Invoice.",
      "Title": "Conditions d'utilisation d'Invoice"
    },
    "Controlling": {
      "ApproveInvoice": "Marquer la facture comme collectée",
      "ApproveInvoiceDialogText": "Veuillez confirmer que vous souhaitez marquer cette facture comme étant collectée.",
      "DeclineInvoice": "Refuser une facture",
      "DeclineInvoiceDialogText": "Veuillez indiquer les raisons pour lesquelles cette facture est refusée.<br>Le texte sera transmis par e-mail à l'utilisateur, veuillez donc ne pas saisir les données du patient.",
      "ShowInvoice": "Afficher la facture"
    },
    "DeclinedDate": "Refusé le",
    "Delegations": {
      "AddDelegation": "Ajouter une délégation",
      "DelegateNotRegistered": "Compte non enregistré chez Contracto ou pas encore associé à Hirslanden.",
      "Description": "Les utilisateurs suivants peuvent créer des factures en votre nom :",
      "Dialog": {
        "AllInstitutionsTooltip": "Votre délégation peut établir automatiquement des factures pour les institutions avec lesquelles vous avez conclu des contrats en tant que médecin agréé",
        "ButtonCancel": "Annuler",
        "ButtonDelete": "Terminer la délégation",
        "ButtonInvite": "Inviter",
        "ButtonUpdate": "Actualiser",
        "ConfirmationCreate": "Avec <strong>Inviter</strong> , vous confirmez que la personne indiquée peut établir des factures à votre nom",
        "ConfirmationUpdate": "Avec <strong>Actualiser</strong> , vous modifiez les autorisations de la délégation",
        "DescriptionCreate": "Invitez une personne qui pourra établir des factures pour vous en tant que délégation",
        "DescriptionEdit": "Modifier la délégation et ses autorisations",
        "EmailLabel": "Adresse e-mail de la délégation",
        "EmailNotFound": "L'adresse e-mail n'a pas pu être trouvée. La personne doit déjà être enregistrée en tant que délégation pour pouvoir être ajoutée.",
        "EmailRequired": "Veuillez saisir une adresse e-mail valide",
        "EmailValidated": "Adresse e-mail validée avec succès",
        "EmailValidationError": "Erreur lors de la validation",
        "ErrorCreate": "Erreur lors de l'établissement de la délégation",
        "ErrorDelete": "Erreur lors de la fin de la délégation",
        "ErrorUpdate": "Erreur lors de la mise à jour de la délégation",
        "InstitutionQuestion": "Pour quelles institutions la délégation peut-il établir des factures?",
        "InstitutionRestrictedTooltip": "Cette institution est gérée de manière externe.",
        "InvalidUserTypeError": "L'utilisateur n'a pas la classe d'utilisateur requise 'Délégation'.",
        "InvalidUserTypeTooltip": "Il n'est pas possible d'actualiser ou de mettre fin à la délégation.",
        "ModeAllInstitutions": "Toutes les institutions",
        "ModeSpecificInstitutions": "Seulement certaines institutions",
        "NoInternalInstitutions": "Sélectionnez au moins une institution",
        "RestrictedInstitutionsTitle": "Institutions Hirslanden",
        "RestrictedInstitutionsWarning": "Pour les institutions de Hirslanden, les délégations sont gérées dans le <a href=\"https://fiori.hirslanden.ch/\" target=\"_blank\" rel=\"noopener noreferrer\">cockpit des médecins</a> ",
        "SuccessCreated": "Délégation créée avec succès",
        "SuccessDeleted": "Délégation terminée avec succès",
        "SuccessUpdated": "Mise à jour réussie de la délégation"
      },
      "DoctorCockpitLink": "Cockpit des médecins Hirslanden",
      "EditDelegation": "Traiter la délégation",
      "ExternalDelegationDeleteTooltip": "Cette délégation est gérée en externe et ne peut être arrêtée que dans le cockpit médecins.",
      "IdpLoginRequired": "Connectez-vous avec votre compte Hirslanden pour voir les délégations gérées en externe.",
      "NoDelegations": "Pas des délégations disponible",
      "NoInternalInstitutionsTooltip": "Vous n'avez pas d'institutions gérées en interne. Les délégations pour les institutions gérées en externe peuvent être gérés dans le cockpit des médecins.",
      "Table": {
        "Action": "Action",
        "Edit": "Modifier",
        "Email": "Adresse électronique",
        "Institutions": "Institutions libérées"
      },
      "Tooltip": {
        "Extern": "externe",
        "NoInstitutions": "Aucune institution",
        "Title": "Institutions libérées"
      }
    },
    "LastSentDate": "Envoyé le",
    "ServiceProvider": {
      "GroupTranslations": {
        "Anesthesiologists": "Anesthésistes",
        "Angestellte Ärzte": "Médecins salariés",
        "Anästhesisten": "Anesthésistes",
        "Gastassistenten": "Assistants invités"
      },
      "Info": "Dans la liste \"Assistants avec contrats\" n'apparaissent que les médecins qui, le jour de l'admission du patient pour la clinique dans laquelle il a été traité, ont un contrat valable avec l'assurance choisie.<br><br> Tous les autres médecins doivent être saisis une fois manuellement comme assistants invités (et annoncés au préalable une fois aux assurances partenaires dans la rubrique Info).<li>Pour les médecins avec un contrat LCA valable le jour de l'admission du patient pour la clinique - son propre facteur est valable pour l'assistant.</li><li>Pour les assistants invités sans contrat LCA valable le jour d'entrée du patient pour la clinique - le facteur du responsable du cas est repris.</li><br> Si le médecin a un contrat valable avec l'assurance, il ne peut pas être utilisé en parallèle comme médecin invité.<br>Veuillez noter qu'en cas de rattachement rétroactif (possible jusqu'à 4 mois après le jour d'entrée) ou de facturation retardée, la facture peut être établie correctement la première fois si le statut contractuel de tous les assistants est clair.",
      "ManagementLinkText": "Lien vers la saisie de {{Name}}",
      "NoServiceProvidersAvailable": "Aucun prestataire disponible pour la sélection."
    },
    "ServiceProviders": {
      "Header": "Invoice médecins"
    },
    "Status": {
      "Approved": "Récupéré",
      "Declined": "Refusé",
      "Draft": "Projet",
      "Sent": "Envoyé à"
    }
  },
  "Languages": {
    "de-CH": "Allemand",
    "fr-CH": "Français",
    "it-CH": "Italien"
  },
  "Nav": {
    "Dropdowns": {
      "Admin": "Admin",
      "Invoice": "InvoicePro"
    },
    "Links": {
      "AcceptInvoiceTerms": "Accepter les conditions d'utilisation",
      "AdminInfo": "Info administrateur",
      "Catalogs": "Catalogues",
      "ChangePassword": "Modifier le mot de passe",
      "ConfigureOtp": "Configurer l'authentification à deux facteurs",
      "Contracts": "Contrats-cadres",
      "Dashboard": "Tableau de bord",
      "Delegation": "Délégation",
      "EditProfile": "Modifier le profil",
      "Emails": "E-mails",
      "Employee": "Listes de médecins",
      "EventLogs": "Journaux d'événements",
      "Info": "Info",
      "Institutions": "Institutions",
      "InsuranceContracts": "Contrats",
      "Insurances": "Assurances",
      "Invoice": "InvoicePro",
      "InvoiceControlling": "Contrôle",
      "InvoiceDelegations": "Délégations",
      "InvoiceManual": "Instructions InvoicePro",
      "InvoiceServiceProviders": "Invoice médecins",
      "InvoiceTerms": "Conditions d'utilisation",
      "Invoices": "Factures",
      "LinkHin": "Lier le login HIN",
      "LinkIdp": "Associer le login {{idp}}",
      "Logout": "Déconnexion",
      "Patients": "Patients",
      "PendingInsuranceContracts": "Contrats en cours de traitement",
      "Rules": "Règles",
      "Statistics": "Statistiques",
      "UserContracts": "Mes contrats",
      "UserGroups": "Groupes",
      "UserManagement": "Utilisateur",
      "UserManagementPending": "Demandes"
    },
    "Menus": {
      "UserMenu": "Menu utilisateur"
    },
    "Title": "Medicalculis",
    "Welcome": "Bienvenue"
  },
  "ObjectPermissions": {
    "CanCreate": "Créer",
    "CanDelete": "Supprimer",
    "CanExport": "Exporter",
    "CanRead": "Lire",
    "CanUpdate": "Actualiser",
    "Object": "Type d'objet",
    "ObjectId": "Objet",
    "ObjectTypeDescriptions": {
      "User": "Tous les utilisateurs",
      "UserContract": "Contrats de l'assurance"
    },
    "ObjectTypes": {
      "CatalogItem": "Catalogue Positions",
      "CatalogView": "Vue du catalogue",
      "Employee": "Listes de médecins",
      "InfoLinks": "Liens d'information",
      "UserContract": "Contrats"
    }
  },
  "Providers": {
    "Paginator": {
      "FirstPage_Label": "Première page",
      "ItemsPerPage_Label": "Enregistrements par page",
      "LastPage_Label": "Dernière page",
      "NextPage_Label": "Page suivante",
      "Of_Label": "sur",
      "PreviousPage_Label": "Page précédente"
    }
  },
  "Roles": {
    "Description": {
      "Admin": "L'utilisateur peut attribuer des rôles d'administrateur",
      "CloseContractsEmail": "L'utilisateur reçoit un e-mail lorsqu'une nouvelle proposition de contrat a été faite. (L'utilisateur doit également être affecté à l'assurance)",
      "CloseContractsUser": "Les demandes de contrat peuvent être soumises par l'utilisateur.",
      "Delegate": "Les utilisateurs peuvent créer des factures pour le compte d'autres personnes",
      "EditContracts": "Les contrats peuvent être acceptés ou refusés.",
      "FileUpload": "L'utilisateur peut télécharger des fichiers.",
      "Invoice": "Les factures de l'utilisateur peuvent être consultées et modifiées.",
      "InvoiceControlling": "L'utilisateur peut consulter, confirmer et refuser les factures de l'assurance.",
      "InvoiceControllingEmail": "L'utilisateur reçoit un e-mail lorsque des factures sont envoyées au contrôle de gestion.",
      "RoleManagement": "Des rôles peuvent être attribués aux utilisateurs.",
      "UserManagement": "Les utilisateurs peuvent être administrés.",
      "UserRegisterEmail": "L'utilisateur reçoit un e-mail lorsque de nouveaux utilisateurs s'inscrivent.",
      "ViewContracts": "Les contrats peuvent être vus."
    }
  },
  "Statistics": {
    "Filter": {
      "DateFrom": "Période de",
      "DateTo": "jusqu'à",
      "ExcelExport": "Exporter Excel",
      "FeesReport": "Exporter le rapport sur les frais",
      "Institutions": "Institutions officielles",
      "Insurances": "Assurances",
      "LoadStatistics": "Charger des statistiques",
      "Option": {
        "AllInstitutions": "Toutes les institutions",
        "AllInsurances": "Toutes les assurances"
      },
      "Placeholder": {
        "SelectInstitutions": "Toutes les institutions",
        "SelectInsurances": "Toutes les assurances"
      }
    },
    "InvoiceStatusPerUser": {
      "Table": {
        "Header": {
          "Approved": "Accepte",
          "Declined": "Refusé",
          "Draft": "Projet",
          "Name": "Nom",
          "Sent": "Envoyé"
        },
        "NoData": "Aucune donnée disponible",
        "Totals": "Total"
      },
      "Title": "Factures par utilisateur selon le statut de traitement"
    },
    "JoinedDoctorsByInsuranceAndInstitution": {
      "Doctors": {
        "Table": {
          "Header": {
            "ContractMonth": "Contrat Medicalculis signé en mois",
            "ContractYear": "Contrat signé avec Medicalculis en",
            "Count": "Nombre",
            "Institution": "Institution",
            "Insurance": "Assurance"
          },
          "NoData": "Aucune donnée disponible"
        },
        "Title": "Médecins adhérents sous contrat Medicalculis par institution et date d'adhésion"
      },
      "Invoices": {
        "Table": {
          "Header": {
            "AverageAmount": "Montant moyen de la facture",
            "Count": "Nombre",
            "Institution": "Institution",
            "Insurance": "Assurance",
            "SentMonth": "Envoyé en mois",
            "SentYear": "Envoyé dans l'année",
            "TotalAmount": "Montant total de la facture"
          },
          "NoData": "Aucune donnée disponible"
        },
        "Title": "Factures envoyées par institution et assurance (sans celles qui ont été refusées)",
        "Totals": "Total"
      }
    },
    "Table": {
      "CollapsedMessage": "Cliquez ici pour afficher le tableau"
    },
    "Tabs": {
      "ContractsOverview": "Aperçu des contrats",
      "DoctorsAndInvoices": "Médecins et factures"
    },
    "Tiles": {
      "ApprovedCount": "Accepte",
      "AverageAmount": "Montant moyen",
      "DeclinedCount": "Refusé",
      "DoctorDistributionByInstitution": {
        "Table": {
          "Header": {
            "Count": "Nombre",
            "Institution": "Institution",
            "Percentage": "Pourcentage"
          },
          "NoData": "Aucune donnée disponible"
        },
        "Title": "Répartition des médecins par institution"
      },
      "DraftCount": "Brouillons",
      "InvoicesSubtitle": "Nombre total de factures envoyées",
      "SentCount": "Envoyé",
      "TotalAmountSubtitle": "Total de toutes les factures envoyées",
      "TotalDoctors": "Nombre de médecins",
      "TotalDoctorsWithContract": "Médecins sous contrat",
      "TotalDoctorsWithContractSubtitle": "Nombre total de médecins ayant un contrat actif",
      "TotalInvoices": "Factures",
      "TotalSum": "Montant de la facture"
    },
    "Title": "Statistiques"
  },
  "SupportWidget": {
    "ConfirmationMessage": "Votre message a été envoyé avec succès.",
    "ContactFormTitle": "Prise de contact",
    "OpenHelp": "Ouvrir l'aide",
    "Submit": "Envoyer",
    "WelcomeMessage": "Bienvenue au centre d'assistance"
  },
  "Url": {
    "InvoiceManualPdf": "/pdf/Instructions_InvoicePro.pdf"
  },
  "User": {
    "Contracts": {
      "AcceptOrConfirmSelected": "Demander/confirmer sélectionné",
      "AcceptSelectedDialogText": "Je confirme que je souhaite demander une offre pour les contrats suivants, respectivement conclure un contrat :</br></br>",
      "AcceptSelectedDialogTitle": "Confirmation pour demande d'offre/conclusion de contrat",
      "ConfirmSelectedDialogContractText": "{{Title}}:<br><div style=\"margin-left: 25px;\"> Facteur LCA : Privé = {{VvgP1}} Demi-privé = {{VvgP2}}<br> Total : Privé = {{FactorP1}} Demi-privé = {{FactorP2}}<br> Facteur individuel : {{IndividualFactor}}<br> Valable de {{ValidFrom}} à {{ValidUntil}}</div>",
      "ConfirmSelectedDialogContractTextWithoutCompensation": "{{Title}}: {{Validity}}",
      "ConfirmSelectedDialogContractValidity": "Valable du {{ValidFrom}} au {{ValidUntil}}",
      "ConfirmSelectedDialogContractValidityFromConfirmation": "Valable à compter de la confirmation jusqu'au {{ValidUntil}}",
      "ConfirmSelectedDialogText": "Je confirme que je souhaite conclure les contrats suivants, y compris tous les avenants, de manière juridiquement contraignante. En outre, j'accepte par la présente les dispositions contractuelles générales qui règlent les détails du contrat.</br></br>",
      "ConfirmSelectedDialogTitle": "Confirmation de la conclusion du contrat",
      "ContractNameHeader": "Nom",
      "ContractStatusHeader": "Statut",
      "ContractValidFromHeader": "Valable dès le",
      "ContractValidUntilHeader": "Valable jusqu'au",
      "DeclineSelectedDialogText": "Vous avez l'intention de refuser les offres suivantes.<br>Contactez l'assurance par e-mail.<br>En cas de refus, l'assurance sera informée du refus par e-mail.<br>Après le refus, vous pouvez directement soumettre une nouvelle demande d'offre ici.</br></br>",
      "DeclineSelectedDialogTitle": "Refuser une/des offre(s) de contrat",
      "Errors": {
        "NoContractsSelectedText": "Aucun contrat n'a été sélectionné.",
        "NoContractsSelectedTitle": "Aucun contrat sélectionné",
        "SelectActiveOrIsUserConfirmationPendingContractsOnlyText": "Veuillez sélectionner uniquement les contrats actifs ou les contrats en attente de confirmation.",
        "SelectActiveOrIsUserConfirmationPendingContractsOnlyTitle": "Sélection de contrat non valide",
        "SelectInactiveContractsOnlyText": "Veuillez ne sélectionner que les contrats qui ne sont pas encore actifs.",
        "SelectInactiveContractsOnlyTitle": "Sélection de contrat non valide",
        "SelectPendingOrUserConfirmationPendingContractsOnlyText": "Veuillez sélectionner uniquement les demandes de contrat ou les confirmations de contrat simultanément.",
        "SelectPendingOrUserConfirmationPendingContractsOnlyTitle": "Sélection de contrat non valide",
        "SmsVerificationFailedDialogText": "Code SMS erroné !",
        "SmsVerificationFailedDialogTitle": "Code SMS incorrect.",
        "UserContractNegativeListBlockedContactInsuranceText": "Vous n'êtes pas autorisé(e) à souscrire / confirmer les contrats suivants :{{contracts}}Pour plus d'informations, veuillez vous adresser directement à la compagnie d'assurance.",
        "UserContractNegativeListBlockedContactMailText": "Vous n'êtes pas autorisé(e) à demander / valider les contrats suivants :{{contracts}}Pour plus d'informations, veuillez vous adresser directement à <a href=\"mailto:{{email}}\">{{email}}</a>",
        "UserContractNegativeListBlockedTitle": "Demande/confirmation impossible",
        "UserMustEnterMobileDialogText": "Pour conclure des contrats, un numéro de téléphone portable doit être enregistré dans le profil d'utilisateur. Veuillez le saisir dans vos paramètres d'utilisateur.",
        "UserMustEnterMobileDialogTitle": "Le numéro de téléphone portable doit être enregistré"
      },
      "FilterUserContracts": "Afficher les contrats inactifs",
      "Header": "Contrats",
      "InfoText": "<p><b>Ici, vous pouvez voir vos contrats et conclure des contrats en ligne :</b></p> <ul> <li> Les contrats acceptés ici sont juridiquement contraignants.</li><li> Sous \"Contenu du contrat\", vous pouvez consulter les textes des contrats au format PDF.</li><li> Sélectionnez les contrats souhaités et confirmez en cliquant sur le bouton correspondant.</li></ul>",
      "SelectAll": "Sélectionner tout",
      "TerminateOrDeclineSelected": "Annuler/refuser les objets sélectionnés",
      "TerminateSelectedDialogContractAdvice": "<b>Important</b>: les avenants au contrat spécifiques à un site ne seront pas résiliés si un autre contrat est conclu entre le site concerné et une compagnie d'assurance.",
      "TerminateSelectedDialogContractOutsideWithdrawalText": "Résiliation (aujourd'hui) pour le {{TerminationDate}} conformément au délai de préavis.",
      "TerminateSelectedDialogContractText": "{{Title}}:<br><div style=\"margin-left: 25px;\">{{Text}}</div>",
      "TerminateSelectedDialogContractVariousTerminationDatesHint": "Tous les contrats n'ont pas la même date de résiliation par défaut. Si vous saisissez une date ici, la date de résiliation sélectionnée sera utilisée pour tous les contrats.",
      "TerminateSelectedDialogContractWithinWithdrawalText": "Résiliation dans le délai de rétractation, la résiliation est immédiate.<br>Le délai de rétractation est de {{WithdrawalPeriod}} jours.",
      "TerminateSelectedDialogText": "Je confirme que je souhaite résilier les contrats suivants de manière juridiquement contraignante :</br></br>",
      "TerminateSelectedDialogTitle": "Confirmation de la résiliation du contrat",
      "UserMustEnterMobile": "<p>⚠️ Pour pouvoir conclure des contrats, un numéro de téléphone portable doit être enregistré dans le profil d'utilisateur. Pour finaliser une demande, un code est envoyé par SMS et doit être saisi pour confirmation. Veuillez le saisir dans vos paramètres d'utilisateur.<br><a class=\"color-white\" href=\"#\" routerlink=\"user/profile\"> Lien vers le profil d'utilisateur</a></p>",
      "ValidFromOnConfirmation": "à compter de la confirmation"
    },
    "Delegation": {
      "Account": "Compte",
      "ContractoCoreAccount": "Contracto Core",
      "CurrentDelegator": "Délégation pour médecin agréé",
      "DelegationInformation": "Vous pouvez établir des factures pour le compte des utilisateurs suivants :",
      "DelegatorNeedsToRegister": "⚠️ Pas de médecin traitant associé",
      "Description": "Vous pouvez créer des factures pour le compte des utilisateurs suivants :",
      "Header": "Délégation",
      "NoDelegations": "Ils n'ont pas des délégations.",
      "SourceInternal": "Interne",
      "Table": {
        "Action": "Action",
        "ConfirmEndMessage": "Vous souhaitez vraiment mettre fin à la délégation pour {{name}} ? Vous ne pourrez ensuite plus établir de factures pour le compte de cet utilisateur.",
        "ConfirmEndTitle": "Mettre fin à la délégation",
        "Email": "Adresse E-mail",
        "EndDelegation": "Terminer la délégation",
        "EndDelegationExternalTooltip": "Cette délégation est gérée en externe et il n'est pas possible d'y mettre fin ici.",
        "ExternalBadge": "géré en externe",
        "Institutions": "Institutions libérées",
        "LinkageMissing": "Lien manquant",
        "LinkageMissingTooltip": "Le médecin traitant ne s'est pas lié à un compte. Ceci est nécessaire pour pouvoir établir des factures.",
        "Name": "Prénom et nom de famille",
        "Tooltip": {
          "Extern": "externe",
          "NoInstitutions": "Aucune institution",
          "Title": "Institutions libérées"
        }
      },
      "UserInfos": {
        "GrantedTitle": "Délégations attribués",
        "NoDelegations": "Cet utilisateur n'a pas de délégations.",
        "ReceivedTitle": "Délégations effectués",
        "SourceContracto": "Dans Contracto",
        "SourceDoctorCockpit": "Via le Cockpit médical Hirslanden"
      },
      "YourAccount": "Votre compte : "
    },
    "Errors": {
      "EmployedFromAfterEmployedUntil": "La date doit être antérieure à la date d'engagement.",
      "EmployedUntilAfterEmployedFrom": "La date doit être placée après la date."
    },
    "Groups": {
      "AddGroup": "Ajouter un groupe",
      "AddObjectPermission": "Ajouter un droit d'objet",
      "AdminGroup": "Groupe Admin",
      "DeleteObjectPermission": "Supprimer",
      "EditGroup": "Modifier le groupe",
      "Errors": {
        "NameRequired": "Le nom doit être complété.",
        "ObjectPermissionNotUnique": "Entrée incomplète."
      },
      "GroupType": "Type de groupe",
      "Header": "Groupes d'utilisateurs",
      "InvoiceGroup": "Groupe Invoice",
      "InvoiceGuestAssistant": "Invoice Assistant invité",
      "Types": {
        "EmployeePerInstitution": "Liste de médecins par institution",
        "EmployeePerUser": "Liste de médecins par utilisateur",
        "Standard": "Standard"
      }
    },
    "Insurance": {
      "CanApproveUserContracts": "Peut proposer / refuser / résilier des contrats",
      "ContractManager": "Responsable des contrats",
      "Function": "Fonction",
      "FunctionHint": "Votre fonction est gérée par healthinal. Veuillez contacter le service d'assistance si vous avez besoin d'autorisations supplémentaires.",
      "InsuranceRequired": "Veuillez choisir une assurance.",
      "Reviewer": "contrôleur de performance"
    },
    "Invoice": {
      "AddAnesthesiaSession": "Saisir le temps d'anesthésie",
      "AddAssistant": "Ajouter un assistant",
      "AddEditVisits": "Ajouter/modifier des visites",
      "AddInvoiceSession": "Ajouter une séance",
      "CloneInvoice": "Copier une facture",
      "CopyBesrToClipboard": "Copier le numéro de référence dans le presse-papiers",
      "DeleteInvoiceSession": "Supprimer une séance",
      "DeleteInvoiceSessionDialogText": "Voulez-vous vraiment supprimer cette séance ?",
      "DeleteServiceProvider": "Supprimer les postes de ce prestataire",
      "DeleteServiceProviderDialogText": "Ce prestataire doit-il vraiment être supprimé de la séance ?",
      "DownloadInvoiceXml": "Télécharger la facture au format XML (Forum Datenaustausch)",
      "EditAnesthesiaSession": "Traiter le temps d'anesthésie",
      "EditAssistant": "Modifier l'assistant",
      "EditInvoiceSession": "Modifier les suppléments",
      "EditInvoiceSurcharges": "Modifier les suppléments",
      "EditPositions": "Modifier les positions tarifaires",
      "EditVisits": "Modifier les visites",
      "InvoiceApprovedChildInvoiceInfoText": "Une copie de cette facture a déjà été créée :",
      "InvoiceApprovedInfoText": "Cette facture a été acceptée et ne peut plus être traitée.",
      "InvoiceApprovedNoChildInvoiceInfoText": "Vous pouvez créer une copie de la facture en cliquant sur le lien suivant :",
      "InvoiceDeclinedChildInvoiceInfoText": "Une copie de cette facture a déjà été créée :",
      "InvoiceDeclinedInfoText": "Cette facture a été rejetée au motif suivant :",
      "InvoiceDeclinedNoChildInvoiceInfoText": "Veuillez créer une copie de la facture via le lien suivant afin de pouvoir l'envoyer à nouveau :",
      "NoPositionForAssistantInfoText": "Aucune assistance ne peut être facturée pour cette position.",
      "NoPositionForServiceProviderInfoText": "Aucune position trouvée pour ce fournisseur de prestations.",
      "ParentInvoiceInfoText": "Ce calcul est dérivé du calcul suivant :",
      "QrReferenceRequired": "Référence QR requise",
      "QrReferenceRequiredError": "Une référence QR est nécessaire pour le destinataire de la facture sélectionné. Veuillez saisir la référence QR via le bouton d'édition de la facture avant de l'envoyer.",
      "SendInvoice": "Envoyer la facture",
      "SendInvoiceDialogText": "Veuillez confirmer que vous souhaitez envoyer cette facture. Aucune modification n'est possible par la suite.",
      "SendInvoiceDialogWithInvoiceReceiverText": "Cette facture est envoyée par voie électronique à <strong>{{ receiverName }}</strong>. Veuillez ne pas envoyer la facture par d'autres moyens.",
      "ShowInvoicePdf": "Afficher la facture"
    },
    "InvoiceVisits": {
      "ChangeServiceProvider": "Saisir les visites pour d'autres prestataires de soins",
      "SurchargeDisabledTooltip": "Un supplément pour visite ne peut être sélectionné qu'en combinaison avec une visite le même jour",
      "Title": "Ajouter des visites"
    },
    "Invoices": {
      "AddInvoice": "Créer une facture",
      "AddInvoiceForPatient": "pour le patient :",
      "AdditionalConfirmation": "Je confirme que j'ai un contrat valide avec {{ invoiceReceiver }}",
      "AssignmentAnd": "et",
      "AssignmentFrom": "à partir de",
      "AssignmentUntil": "jusqu'à",
      "BackToSsoLogin": "Avec {{ sso }} Se connecter au compte et sélectionner directement le cas",
      "CaseInsurance": "Assurance dans le cas choisi",
      "CaseReset": "Annuler",
      "CaseSearchLabel": "Reprendre les données d'un cas",
      "CaseSearchPlaceholder": "Prénom Nom de famille 01.01.1990",
      "CaseSearchResultCount": {
        "Plural": "{{ count }} Cas trouvés",
        "Singular": "1 résultat trouvé"
      },
      "CaseSearchSearching": "On recherche des cas…",
      "CaseSet": "Données reprises du cas {{ caseNumber }}. Vérifie et complète les informations si nécessaire.",
      "CaseTreatmentCategories": {
        "General": "Généralités",
        "Private": "Privé",
        "SemiPrivate": "Demi-privé"
      },
      "DeleteInvoice": "Supprimer une facture",
      "DeleteInvoiceText": "Faut-il vraiment supprimer cette facture ?",
      "EditInvoice": "Modifier la facture",
      "EditPatient": "Modifier le patient",
      "EditPatientMarker": "(Édité)",
      "Errors": {
        "AdditionalPatientDataRequired": "Veuillez compléter les informations nécessaires concernant le patient.",
        "BankAccountIbanRequired": "L'IBAN doit être rempli.",
        "BesrInvalid": "La référence QR saisie n'est pas valide.",
        "CaseDataDifference": "Données de cas différentes ('{{caseData}}')",
        "CaseNumberInvalid": "Veuillez saisir un nombre de 10 chiffres maximum.",
        "CaseNumberRequired": "Veuillez saisir un numéro de cas.",
        "ContractRequired": "Veuillez sélectionner un contrat",
        "HospitalizationFromAfterHospitalizationUntil": "La date doit être antérieure à la date d'hospitalisation au.",
        "HospitalizationFromRequired": "Veuillez saisir l'hospitalisation de la date.",
        "HospitalizationUntilBeforeHospitalizationFrom": "La date doit être postérieure à l'hospitalisation de la date.",
        "HospitalizationUntilRequired": "Veuillez indiquer l'hospitalisation jusqu'à la date.",
        "InsuranceRequired": "Veuillez sélectionner l'assurance",
        "InsuranceTypeRequired": "Veuillez sélectionner un type d'assurance",
        "MinLengthThree": "Veuillez utiliser au moins trois caractères",
        "NoActiveContract": "Pas de contrat actif à la date {{ date }}",
        "PatientRequired": "Veuillez sélectionner ou créer le patient",
        "ZsrNumberRequired": "Un RCC est nécessaire pour la facturation."
      },
      "ForPatient": "de patient",
      "GenerateBesr": "Générer automatiquement",
      "GenerateBesrDisclaimer": "Nous recommandons de créer ce numéro de référence dans le système comptable externe, afin que les paiements puissent y être correctement suivis. Si cela n'est pas nécessaire ou pas possible, la référence peut être générée ici. Nous déclinons toute responsabilité en cas d'erreurs de traitement ou de conséquences liées à la traçabilité des paiements dans le système comptable externe utilisé lors de la génération automatique de la référence QR.",
      "Header": "Factures",
      "Hints": {
        "BesrRequiredForSending": "Le destinataire de la facture sélectionné nécessite une référence QR. Celle-ci doit être saisie avant l'envoi de la facture.",
        "GenerateBesr": "En créant la facture, le numéro de référence est automatiquement généré. Celui-ci est ensuite visible dans le PDF et sous 'Modifier la facture'.",
        "SessionPositionOutOfDateRange": "Une ou plusieurs positions sélectionnées se trouvent en dehors de la période de facturation (hospitalisation de/à). Veuillez adapter la période ou supprimer les positions concernées.",
        "SessionPositionSourceIsDraft": "Ce poste provient d'une facture encore à l'état de projet",
        "SessionPositionsDerivable": "Pour les anesthésistes : reprendre les positions disponibles d'une facture d'opérateur existante",
        "SessionPositionsDerivableInfo": "Une facture d'opérateur existe déjà pour le numéro de cas saisi et le contrat sélectionné. Sélectionnez les positions qui doivent être reprises."
      },
      "InvalidQrIban": "L'IBAN saisi n'est pas un QR-IBAN valide. Pour l'envoi au destinataire de facture sélectionné, un QR-IBAN valide doit impérativement être enregistré.",
      "InvoiceReceiverSettings": {
        "Errors": {
          "SettingPattern": "Format non valide",
          "SettingRequired": "Réglage nécessaire"
        },
        "Fields": {
          "cdm": {
            "accountNumber": "Numéro de compte"
          },
          "medidata": {
            "clientId": "MediData client id",
            "gln": "GLN (fictif)"
          },
          "zak": {
            "contractId": "Caisse d'assurance dentaire - Numéro de contrat"
          }
        },
        "Hints": {
          "cdm": "Indiquez ici votre numéro de compte. Sinon, votre RCC (de facturation) ou personnel sera utilisé.",
          "zak": "Saisissez ici l'identifiant de contrat (Contract ID) que vous avez reçu de la Caisse dentaire lors de votre inscription."
        },
        "MediData": {
          "Instruction1": "Veuillez demander votre connexion <a href='https://www.medidata.ch/md/online/public/onboarding/forms/' target='_blank'>ici</a>.<br />Veuillez sélectionner <b>Contracto (Medicalculis InvoicePro)</b> comme <b>fournisseur de logiciel</b> et indiquer <b>le GLN suivant</b>:",
          "Instruction2": "L'activation se fait normalement dans les 24-48 heures.<br />Nous vous informerons dès que votre onboarding sera terminé.",
          "Intro": "Vous avez besoin d'une nouvelle connexion MediData payante.",
          "RequestNow": "Demander maintenant"
        },
        "SettingsMissing": "Des réglages supplémentaires sont nécessaires pour ce récepteur",
        "Title": "Paramètres",
        "Zak": {
          "Contact": "Pour la procédure d'intégration, veuillez vous adresser à votre conseiller clientèle de la Caisse des dentistes.",
          "Instruction": "Vous devez ensuite saisir le numéro de contrat (Contract ID) reçu de la caisse dentaire dans <b>les paramètres</b>.",
          "Intro": "Pour envoyer vos factures à la Caisse dentaire, vous avez besoin d'un identifiant de contrat (Contract ID). La Caisse dentaire vous accompagne tout au long du processus d'intégration."
        }
      },
      "InvoiceReceiverStatus": {
        "InvoiceReceiverLink": "Ouvrir à {{ invoiceReceiverTitle }}",
        "InvoiceReceiverReference": "Référence",
        "InvoiceReceiverStatusChangedDate": "Dernière modification",
        "InvoiceReceiverStatusDetails": "Détails",
        "Label": "Statut du destinataire",
        "Status": {
          "MediData.Accepted": "Adopté",
          "MediData.Pending": "Refusé (données manquantes)",
          "MediData.Rejected": "Refusé",
          "Zak.Accepted": "Adopté",
          "Zak.Pending": "Vérification nécessaire (voir la colonne « Détails »)",
          "Zak.Rejected": "Rejeté"
        }
      },
      "InvoiceReceiverTitles": {
        "Caisse des Médecins": "Caisse des Médecins"
      },
      "InvoiceReceivers": "Destinataire de la facture",
      "LogInWithSso": "Se connecter avec un compte {{ sso }}",
      "LogInWithSsoNudge": "Nouveau : veuillez vous connecter avec votre compte {{ sso }} pour sélectionner directement un cas",
      "ManualDataEntryHint": "Vous ne trouvez pas le dossier ?",
      "ManualDataEntryLink": "Saisir les données manuellement",
      "NewPatient": "Nouveau patient",
      "NewPatientMarker": "(Nouveau)",
      "NoCasesFound": {
        "EarliestCaseStart": "Le début de chute le plus précoce dans le système est le {{ earliestCaseStart }}.",
        "NoCasesAvailable": "Il n'y a pas de cas dans le système",
        "NoUserAssignment": "Selon nos données partenaires, vous n'avez actuellement pas accès",
        "Reasons": "Raisons possibles :",
        "RetentionHint": "Les données de cas sont disponibles {{ retentionInMonths }} Mois disponibles - les cas plus anciens ne sont donc pas trouvés",
        "SkillIssue": "Corrigez votre demande de recherche",
        "Text": "Aucun cas n'a été trouvé",
        "UserAssignments": "Selon les données de nos partenaires, vous avez accès à des cas :"
      },
      "NoCasesFoundReasons": "Raisons possibles :",
      "NoInvoiceReceiver": "Pas de destinataire de facture électronique",
      "Patient": "Patient",
      "PatientDiffersFromSelectedPatient": "Le patient présélectionné ({{ patientDisplay }}) ne correspond pas exactement aux données du cas et a donc été remplacé.",
      "ProfileDataMissingInfoText": "Pour pouvoir établir une facture, des données doivent être complétées dans votre profil d'utilisateur. Veuillez mettre à jour les champs manquants.",
      "SaveAndCreate": "Enregistrer & créer une facture",
      "SendAnyway": "Envoyer quand même",
      "SetCase": "Reprendre",
      "TreatmentReason": {
        "Accident": "Accident",
        "Disease": "Maladie",
        "Label": "Motif du traitement",
        "Maternity": "Maternité",
        "Prevention": "Prévoyance"
      },
      "UserProfileDataMissing": "Informations de profil incomplètes"
    },
    "Logins": {
      "LoginDate": "Date de connexion"
    },
    "Management": {
      "ApproveUserButtonText": "Partager",
      "ApproveUserText": "Voulez-vous vraiment valider cet utilisateur ?",
      "ApproveUserTitle": "Partager un utilisateur",
      "DeactivateUserButtonText": "Désactiver l'utilisateur",
      "DeactivateUserText": "L'utilisateur ne peut plus se connecter, mais toutes ses données restent inchangées en arrière-plan. Vous pouvez le réactiver à tout moment.",
      "DeactivateUserTitle": "Désactiver l'utilisateur",
      "DeleteUserRequestButtonText": "Supprimer",
      "DeleteUserRequestText": "L'utilisateur et toutes les données associées seront définitivement supprimés. Cette action est irréversible.",
      "DeleteUserRequestTitle": "Supprimer la demande d'un utilisateur",
      "EditUser": "Modifier l'utilisateur",
      "ExcelExportGdpr": "Exportation vers Excel avec des données personnelles",
      "ExcelExportGdprText": "L'exportation contient les données personnelles de tous les utilisateurs et est soumise à la législation sur la protection des données (LPD/RGPD). Ce fichier doit être traité de manière confidentielle, ne doit pas être transmis à des personnes non autorisées et doit être supprimé dès qu'il n'est plus nécessaire. Souhaitez-vous lancer l'exportation ?",
      "Header": "Gestion des utilisateurs",
      "NotifyUserByEmail": "Informer les utilisateurs par e-mail",
      "PendingHeader": "Demandes des utilisateurs",
      "ReactivateUser": "Réactiver un utilisateur",
      "ReactivateUserText": "<p>La réactivation de l'utilisateur déclenche les actions suivantes :</p><ul><li>L'utilisateur peut à nouveau se connecter dès maintenant.</li><li>Une fois connecté, il peut à nouveau accéder à toutes les fonctionnalités.</li><li>Les demandes d'offre en cours réapparaissent dans les listes correspondantes.</li></ul>",
      "ReadOnlyUser": "Utilisateur en lecture seule",
      "ReadOnlyUserText": "L'utilisateur est affecté à plusieurs groupes d'établissements hospitaliers et ne peut donc pas être modifié. Pour toute question, veuillez contacter healthinal."
    },
    "Patients": {
      "AddPatient": "Ajouter un patient",
      "DeletePatient": "Supprimer un patient",
      "DeletePatientText": "Faut-il vraiment supprimer ce patient ?",
      "EditPatient": "Modifier le patient",
      "Errors": {
        "CityRequired": "Veuillez saisir le nom de la ville",
        "DateOfBirthRequired": "Veuillez saisir la date de naissance",
        "FirstNameRequired": "Veuillez saisir le prénom",
        "GenderRequired": "Veuillez sélectionner le sexe",
        "LastNameRequired": "Veuillez saisir le nom de famille",
        "PostalCodeRequired": "Veuillez saisir le code postal"
      },
      "Header": "Mes patients"
    },
    "Profile": {
      "ChangePersonalInfo": "Modifier le nom ou l'adresse e-mail",
      "QrReferencePrefix": "Préfixe de référence QR",
      "QrReferencePrefixTooltip": "Si vous souhaitez générer des numéros de référence, vous pouvez définir ici un préfixe optionnel",
      "SavedSuccessful": "Les nouvelles données d'utilisateur ont été enregistrées"
    },
    "SpecialistQualifications": "Titres de spécialisation validés",
    "SpecialistQualificationsHint": "Ces titres de spécialistes sont validés en externe et sont utilisés, si nécessaire, pour sélectionner le facteur AOS correct.",
    "SpecialistQualificationsNone": "Aucun titre de spécialisation validé n'est disponible.",
    "UserContractNegativeList": {
      "Active": "Actuellement bloqué",
      "NoHistory": "Jamais figuré sur une liste noire.",
      "Ongoing": "en cours",
      "OpenEnd": "à durée indéterminée",
      "Past": "Blocages antérieurs",
      "Planned": "Blocages à venir",
      "Title": "Contrats suspendus"
    },
    "UserStatus": {
      "Active": "Actif",
      "Deleted": "Désactivé",
      "PendingRequest": "Demande en attente"
    },
    "UserType": {
      "Delegate": "Délégation",
      "InstitutionGroupAdmin": "Administrateur du groupe de cliniques",
      "Insurance": "Assurance",
      "NotClassified": "Non attribué",
      "Physician": "Médecin agréé"
    }
  }
}
